import React, { useEffect, useContext, useRef } from 'react';
import { useActor } from '@xstate/react';
import { GlobalStateContext } from '../state/app/index';
import CreatableSelect from 'react-select/creatable';
import { handleRawEvents } from '../dryKeyboardMapping';
import { useHotkeys } from 'react-hotkeys-hook';
import logger from '../logger';
import track from '../utils/trackers';
import FilterListIcon from '@mui/icons-material/FilterList';

const Palette = (props) => {
  const globalServices = useContext(GlobalStateContext);
  const [appState, sendAppState] = useActor(globalServices.appState);
  const {
    context: {
      areasOfFocusCollectionsIterable,
      areasOfFocusCollections,
      selectedAreaOfFocus,
      showCommandPalette,
      paletteType,
    },
  } = appState;
  const paletteRef = useRef();

  const handlePaletteChange = (changeEvent) => {
    const { value: collectionId } = changeEvent;
    logger.info(changeEvent, 'Palette: handlePaletteChange');
    // Ensure that we have a working AOFCOllectionObject

    try {
      // updateAreasOfFocusSelectedCollection(collectionID);
      // saveUserSetting({
      //   selected_area_of_focus: collectionID
      // });

      // Pull from app state if found, otherwise pull from the cloud, otherwise, error
      sendAppState({
        type: 'selectAreasOfFocusCollection',
        data: { collectionId },
        // selectedAreaOfFocus: areasOfFocusCollections.find(aofCollection => aofCollection.area_of_focus_collection_id === collectionId),
      });
      logger.info('save selected area of focus');
    } catch (error) {
      logger.error(error, 'Palette: handlePaletteChange - error');
    }
  };

  const handlePaletteInputChange = (changeEvent) => {
    logger.info(Object.keys(changeEvent), 'Palette: handlePaletteInputChange');
  };

  const onInputChange = (changeEvent) => {
    logger.info(Object.keys(changeEvent), 'Palette: onInputChange');
    // Handle keyboard shortcuts
    handleRawEvents(changeEvent, 'palette');
  };

  const handleMenuClose = () => {
    logger.debug('Palette: handleMenuClose');
    sendAppState({
      type: 'toggleCommandPalette',
    });
  };

  const togglePaletteWrapper = () => {
    logger.debug('Palette: togglePaletteWrapper');
    sendAppState({ type: 'toggleCommandPalette' });
  };

  useHotkeys('esc', () => sendAppState({ type: 'toggleCommandPalette' }), { enabled: showCommandPalette, enableOnFormTags: true });

  let currentAOFCollection = {};
  const options = areasOfFocusCollectionsIterable?.map(
    (aofCollection, index) => {
      const aofCollectionOption = {
        value: aofCollection.area_of_focus_collection_id,
        label: aofCollection.title,
      };

      // Set the current AOF Collection if it matches
      if (
        aofCollection.area_of_focus_collection_id ===
        selectedAreaOfFocus?.area_of_focus_collection_id
      ) {
        currentAOFCollection = aofCollectionOption;
      }

      return aofCollectionOption;
    }
  );

  useEffect(() => {
    track.event('Palette', 'show_palette');
    logger.info('Palette: show_palette');
  }, []);

  // Dynamically change placeholder text
  if (showCommandPalette && options && selectedAreaOfFocus) {
    return (
      <div className="palette-wrapper" onClick={togglePaletteWrapper}>
        <div className="palette" onClick={(e) => e.stopPropagation()}>
          <div className="palette__accent">
            <div className="palette__accent-icon">
              <FilterListIcon sx={{ color: '#fff', fontSize: 26 }} />
            </div>
          </div>
          <div className="palette__body">
            <div className="palette__header">
              <h3 className="palette__title">Switch Area of Focus</h3>
            </div>
            <div className="palette__content">
              {paletteType === 'note' ? (
                <textarea name="" id="" cols="30" rows="10"></textarea>
              ) : (
                <CreatableSelect
                  name="palette-select"
                  className="react-select-container"
                  classNamePrefix="palette-select"
                  onChange={handlePaletteChange}
                  onInputChange={handlePaletteInputChange}
                  onKeyDown={onInputChange}
                  onMenuClose={handleMenuClose}
                  options={options}
                  value={currentAOFCollection}
                  placeholder="Search areas of focus…"
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  styles={{ menuPortal: (base) => ({ ...base, zIndex: 10002 }) }}
                  autoFocus
                  ref={paletteRef}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
  return null;
};

export default Palette;
